module.exports = __webpack_public_path__ + "static/media/split_payment.1481e531.ca4d028d.png";